import { render, staticRenderFns } from "./ServiceCategoriesForm.vue?vue&type=template&id=7f880d86"
import script from "./ServiceCategoriesForm.vue?vue&type=script&lang=js"
export * from "./ServiceCategoriesForm.vue?vue&type=script&lang=js"
import style0 from "./ServiceCategoriesForm.vue?vue&type=style&index=0&id=7f880d86&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports